import { SVGIcon } from '../Icons'
import { ISVGProps } from '../types'

const HeadSet = (props: ISVGProps) => (
  <SVGIcon {...props}>
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.652 2C7.62256 2 5.67625 2.80619 4.24122 4.24122C2.80619 5.67625 2 7.62256 2 9.652V9.95406C2.35999 9.81165 2.75236 9.7334 3.163 9.7334C4.90988 9.7334 6.326 11.1495 6.326 12.8964V15.0594C6.326 16.8063 4.90988 18.2224 3.163 18.2224C1.41612 18.2224 0 16.8063 0 15.0594V12.8965V12.8964V9.652C0 7.09213 1.0169 4.63711 2.82701 2.82701C4.63711 1.0169 7.09213 0 9.652 0C12.2119 0 14.6669 1.0169 16.477 2.82701C18.2871 4.63711 19.304 7.09213 19.304 9.652V12.8965C19.304 12.9068 19.3038 12.917 19.3035 12.9272V15.0594C19.3035 16.511 18.3257 17.7342 16.9927 18.1063C16.6469 19.1066 15.7374 19.8865 14.688 20.4112C13.3004 21.105 11.4886 21.467 9.65234 21.467C9.10006 21.467 8.65234 21.0193 8.65234 20.467C8.65234 19.9147 9.10006 19.467 9.65234 19.467C11.2581 19.467 12.7473 19.1454 13.7935 18.6223C14.27 18.3841 14.5872 18.1426 14.7934 17.922C13.7203 17.4161 12.9775 16.3245 12.9775 15.0594V12.8964C12.9775 11.1495 14.3937 9.7334 16.1405 9.7334C16.5514 9.7334 16.9439 9.81172 17.304 9.95424V9.652C17.304 7.62256 16.4978 5.67625 15.0628 4.24122C13.6278 2.80619 11.6814 2 9.652 2ZM2 12.8965V12.8964C2 12.2541 2.52069 11.7334 3.163 11.7334C3.80531 11.7334 4.326 12.2541 4.326 12.8964V15.0594C4.326 15.7017 3.80531 16.2224 3.163 16.2224C2.52069 16.2224 2 15.7017 2 15.0594V12.8965ZM14.9775 12.8964C14.9775 12.2541 15.4982 11.7334 16.1405 11.7334C16.7828 11.7334 17.3035 12.2541 17.3035 12.8964V15.0594C17.3035 15.7017 16.7828 16.2224 16.1405 16.2224C15.4982 16.2224 14.9775 15.7017 14.9775 15.0594V12.8964Z"
        fill="#242424"
      />
    </svg>
  </SVGIcon>
)

export default HeadSet
